import styled from 'styled-components';

export const Badge = styled.div<{ [key: string]: any }>`
  width: 66px;
  height: 48px;
  border-radius: ${(props) =>
    Number(props.theme.borderRadius) ? `${props.theme.borderRadius}px` : '5px'};
  background-color: ${(props) => props.theme.colors.primaryDark1};
  color: ${(props) => props.theme.colors.white};
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  font-family: ${(props) => props.theme.primaryFont};
  font-size: 16px;
  font-weight: 400;
  line-height: 14.3px;
  letter-spacing: 0em;
  text-align: center;

  @media screen and (max-width: 768px) {
    gap: 1px;

    width: 128px;
    height: 28px;
    top: 736px;
    left: 36px;
    flex-direction: row;
    justify-content: center;

    .mobile-spacing {
      margin-right: 8px;
    }

    .text-mobile {
      position: relative;
      bottom: -1px;
      margin-right: 8px;
      font-size: 11px !important;
      line-height: 14.3px !important;
    }

    .percent-mobile {
      font-size: 16px !important;
      line-height: 20.8px !important;
    }
  }
`;
